var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',[(_vm.data.survey.type === 'extended' || _vm.data.survey.type ==='labor')?_c('survey-climate'):_vm._e(),_vm._v(" "),(_vm.data.survey.type === 'custom' || _vm.data.survey.type ==='mailing')?_c('survey-mailing'):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba613f3a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/surveys/App.vue
// module id = null
// module chunks = 